import type { FaireProductEntity } from "../../entity_types/product";

export const p_44tn3kjac3: FaireProductEntity = {
  token: "p_44tn3kjac3",
  type: "product",
  name: "Mermaid Sequin Bow Baby Headband - Kids Hair Accessories",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/c3e7351920a245daaac5ad704b1c81b2eaad19fd752ef74ac0152da1da21f005.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/999606fa6ebb03bdea59802243a645bf4428a3e2b634c4cafdfe2d0fd1e04e74.jpeg",
    "https://cdn.faire.com/fastly/780e73db82664e1171259e0f7f546686a1b939924e32eaaac88e896c109bff80.jpeg",
    "https://cdn.faire.com/fastly/61bb06a1a372f82ed4c465e89ebe01f3eee3bae8318286348a96ed22c2479f80.jpeg",
    "https://cdn.faire.com/fastly/9196fbd466554323802c2d4a7cd2ef0a8c820bc42a6b61abce806a55794dbd7f.jpeg",
    "https://cdn.faire.com/fastly/a2f88738ad41881ca825888b700a9c240014b10e4b7a9e1d40719b6886858318.jpeg",
  ],
  priceDollars: 6,
  description:
    "Soft, stretchy, and sea-inspired, this tiny mermaid bow headband is perfect for your littlest wave-maker.\n\nFeatures:\n * Soft pink tulle bow with mermaid inspired confetti inside\n * Nylon elastic hair band \n * Recommended for babies 0-24 months \n\nPair this headband with a matching Sweet Wink tutu and shirt for a complete head-to-toe outfit!",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:25.683Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
